import React from "react";

const SecondPlace = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="_2-medal"
    width="72"
    height="72.002"
    className="medals second-place"
    viewBox="0 0 72 72.002"
    aria-label="silver medal position">
    <defs />
    <g id="Mask_Group_272" transform="translate(-3373.635 476.507)">
      <g id="Group_9005">
        <g id="Group_8993">
          <path
            id="Path_15202"
            d="M3402.483-453.146h16.311l18.84-23.36h-16.308z"
            className="cls-1"
          />
          <path
            id="Path_15203"
            d="M3426.879-476.507l-18.841 23.36h5.2l18.841-23.36"
            className="cls-2"
          />
        </g>
        <path
          id="Path_15204"
          d="M3419.272-458.074h-23.243v13.894h4.938v-8.954h18.3v8.954h4.939v-13.894z"
          className="cls-3-trophy2"
        />
        <circle
          id="Ellipse_1691"
          cx="20.414"
          cy="20.414"
          r="20.414"
          className="cls-3-trophy2"
          transform="translate(3389.707 -451.407)"
        />
        <g id="Group_8994">
          <path
            id="Path_15205"
            d="M3418.192-453.146h-16.306l-18.846-23.361h16.311z"
            className="cls-1"
          />
          <path
            id="Path_15206"
            d="M3393.795-476.507l18.841 23.36h-5.2l-18.841-23.36"
            className="cls-2"
          />
        </g>
        <circle
          id="Ellipse_1692"
          cx="15.698"
          cy="15.698"
          r="15.698"
          fill="#adab9e"
          transform="translate(3394.423 -446.691)"
        />
        <g id="_2" className="cls-5">
          <g id="Group_9223" className="cls-5">
            <path
              id="Path_15247"
              d="M3415.676-423.961h-11.209v-2.224l5.29-5.637a13.087 13.087 0 0 0 1.611-2.078 3.329 3.329 0 0 0 .523-1.684 2.5 2.5 0 0 0-.551-1.713 1.983 1.983 0 0 0-1.572-.623 2.14 2.14 0 0 0-1.735.758 3 3 0 0 0-.635 1.993h-3.256a5.363 5.363 0 0 1 .712-2.729 5.026 5.026 0 0 1 2.017-1.937 6.124 6.124 0 0 1 2.953-.7 5.8 5.8 0 0 1 3.925 1.213 4.288 4.288 0 0 1 1.4 3.426 5.5 5.5 0 0 1-.628 2.47 13.7 13.7 0 0 1-2.157 2.931l-3.717 3.919h7.031z"
              className="cls-3-trophy2"
            />
          </g>
        </g>
      </g>
    </g>
    <path
      id="Rectangle_5641"
      fill="none"
      d="M0 0H72V72H0z"
      transform="translate(0 0.002)"
    />
  </svg>
);

export default SecondPlace;
